import React, { Component } from 'react';
import StreamPlayer from '../Stream/StreamPlayer/StreamPlayer';
import StreamDescriptionModal from '../Stream/StreamDescriptionModal/StreamDescriptionModal';
import StreamArtistsModal from '../Stream/StreamArtistsModal/StreamArtistsModal';
import PropTypes from "prop-types";
import coverTheater from '../../images/cover-theater.jpg';
import posterGeneric from '../../images/poster-generic.jpeg';
import { SetComponentLanguage, ApiRequest, generateUuidv4 } from "../../helpers";
import ReactHtmlParser from 'react-html-parser';
import en from '../Stream/locales/en.json';
import fr from '../Stream/locales/fr.json';
import LocalizedStrings from 'react-localization';
const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class StreamUpdates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewerId: null,
            activationCode: 'CDMVM2',
            fetchedVideoInfos: false,
            eventExists: false,
            activeEvent: {},
            streamConfig: {}
        }
    };

    componentDidMount() {
        const viewerId = generateUuidv4();
        this.setState({
            viewerId
        }, () => {
            this.getVideoInfos();
        });
    }

    getVideoInfos = async () => {
        try {
            const streamResponse = await this.fetchStreamInfos();
            console.log('streamResponse: ', streamResponse);
            this.setState({
                streamConfig: streamResponse.data
            });

            if (!streamResponse.data.error) {
                this.setState({
                    fetchedVideoInfos: true
                });
            }

            const activeEventInfoResponse = await this.getActiveEventInfo(streamResponse.data.event_id);
            console.log('active event info response: ', activeEventInfoResponse);
            if(activeEventInfoResponse.data.event){
                let response = activeEventInfoResponse.data.event;

                this.setState({
                    eventExists: true,
                    activeEvent: response
                }, () => {
                    this.props.setStreamEvent(this.state.activeEvent, this.state.streamConfig);
                    
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    getActiveEventInfo = async (eventId) => {
        return await ApiRequest(`/events/public/${eventId}`, {
            method: 'GET'
        });
    };

    fetchStreamInfos = async () => {
        return await ApiRequest(`/stream/access`, {
            method: 'POST',
            data: {
                activation_code: this.state.activationCode,
                viewer_id: this.state.viewerId
            }
        });
    };

    render() {
        return (
            <React.Fragment>
                <div className="showtix-stream">
                    <StreamDescriptionModal
                        isStreamDescriptionModalOpen={this.props.isStreamDescriptionModalOpen}
                        toggleStreamDescriptionModal={this.props.toggleStreamDescriptionModal}
                        activeEvent={this.state.activeEvent}
                    />
                    <StreamArtistsModal
                        isStreamArtistsModalOpen={this.props.isStreamArtistsModalOpen}
                        toggleStreamArtistsModal={this.props.toggleStreamArtistsModal}
                        activeEvent={this.state.activeEvent}
                    />
                    <div className="showtix-section showtix-stream__wrapper" style={{backgroundImage: "url(" + coverTheater + ")"}}>
                        <div className="container showtix-stream__content">
                            <div className="row mb-4">
                                <div className="showtix-stream__content__inner">
                                    <React.Fragment>
                                        { this.state.fetchedVideoInfos
                                            ?
                                            <React.Fragment>
                                                <StreamPlayer
                                                    streamConfig={this.state.streamConfig}
                                                ></StreamPlayer>
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <div className="showtix-stream__placeholder" style={{backgroundImage: "url(" + posterGeneric + ")"}}>
                                                    <div className="showtix-stream__placeholder__overlay"></div>
                                                    <p className="showtix-stream__placeholder__error">{ReactHtmlParser(strings.errorGeneric)}</p>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                </div>
                            </div>
                        </div>
                    </div>
                    <style dangerouslySetInnerHTML={{__html: `
                        .stream-player-initialized .zopim {
                            display: none !important;
                        }
                    `}} />
                </div>
            </React.Fragment>
        );
    }
}

StreamUpdates.propTypes = {
    setStreamEvent: PropTypes.func,
    isStreamDescriptionModalOpen: PropTypes.bool,
    toggleStreamDescriptionModal: PropTypes.func,
    isStreamArtistsModalOpen: PropTypes.bool,
    toggleStreamArtistsModal: PropTypes.func,
};

export default StreamUpdates;


// WEBPACK FOOTER //
// ./src/components/StreamUpdates/StreamUpdates.js